// extracted by mini-css-extract-plugin
export default {"header":"MobileHeader_header__ur2TW","tag":"MobileHeader_tag__UaxAB","logo":"MobileHeader_logo__xVOaX"};